import { SensorOrSubSensorInfoWithoutSection } from '@components/cockpit/panels/monitoring/monitoring.types';
import CoordinatesInformation from '@components/map/popup/common/CoordinatesInformation';
import { getSensorOrSubSensorPositionCoordinates } from '@utils/map/sensor.utils';

type Props = {
  sensorOrSubSensorInfo: SensorOrSubSensorInfoWithoutSection;
};

export default function SensorCoordinatesInformation({ sensorOrSubSensorInfo }: Readonly<Props>) {
  const coordinates = getSensorOrSubSensorPositionCoordinates(
    sensorOrSubSensorInfo.configuration,
    sensorOrSubSensorInfo.status,
  );
  return <CoordinatesInformation coordinates={coordinates} />;
}
